<template>
  <section v-if="showEstimatedTimeRemaining" class="mt-3">
    <h2>{{ $t('timeCalculation.title') }}</h2>
    <div class="progress" role="img">
      <div class="progress__current" :style="{width: completedPercentage}"></div>
    </div>
    <small>
      {{ $t('timeCalculation.remainingTime') }}: {{ formattedDays }}
    </small>
  </section>
</template>

<script>

import moment from 'moment'

export default {
  computed: {
    progress() {
      const now = moment()
      const created = moment(this.currentErrand.created_date)
      const plannedEnd = moment(this.currentErrand.planned_end_date)
      return (now - created) / (plannedEnd - created)
    },
    completedPercentage() {
      return Math.round(this.progress * 100) + '%'
    },
    formattedDays() {
      return moment(this.currentErrand.planned_end_date).fromNow()
    },
    showEstimatedTimeRemaining() {
      return this.currentErrand.planned_end_date && this.currentErrand.features.useEstimatedTimeFrames && this.progress < 1
    }
  }
}
</script>

<style lang="scss" scoped>

.progress {
  height: .625rem;
  margin-bottom: measure(xxs);
  background-color: color(white);
  border-radius: $border-radius-box;
}

.progress__current {
  height: 100%;
  background-color: color(primary);
  border-radius: inherit;
}

</style>
